var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoldstation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 40,
    viewBox: "0 0 97 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0214 0.269287L22.1102 5.91005H17.9643L18.8767 0.269287H13.8551L11.2271 16.5288H16.2486L17.1677 10.84H21.3136L20.3933 16.5288H25.4147L28.0428 0.269287H23.0214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4925 17.6792H27.2104L27.2115 17.6677H22.1912L22.1889 17.6792H17.7122L16.9316 22.6092H21.3923L19.5631 33.9274H24.5834L26.4127 22.6092H30.7131L31.4925 17.6792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7041 33.9274H55.6826L58.3107 17.6677H63.3322L60.7041 33.9274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.517 17.6792H53.2338L53.2361 17.6677H48.2145L48.2122 17.6792H43.7355L42.9561 22.6092H47.4156L45.5864 33.9274H50.608L52.4371 22.6092H56.7375L57.517 17.6792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5726 11.6149L51.4062 0.269287H46.3859L43.7578 16.5288H48.2871H55.3164L56.1107 11.6149H49.5726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.836 2.39829C40.0397 -0.837594 34.6668 -0.778073 30.8379 2.53107C27.0081 5.84135 26.1713 11.1479 28.9676 14.3838C31.764 17.6197 37.1358 17.5601 40.9656 14.2499C44.7957 10.9407 45.6324 5.63418 42.836 2.39829ZM37.9714 10.785C36.4067 12.138 34.2111 12.162 33.0678 10.84C31.9243 9.51792 32.2665 7.34884 33.8323 5.99588C35.3971 4.64292 37.5924 4.61889 38.7359 5.94094C39.8783 7.26415 39.5361 9.43323 37.9714 10.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2408 19.8046C75.4445 16.5688 70.0727 16.6282 66.2427 19.9386C62.4128 23.2489 61.5761 28.5554 64.3724 31.7913C67.1688 35.0273 72.5406 34.9677 76.3704 31.6574C80.1993 28.347 81.0372 23.0405 78.2408 19.8046ZM73.3749 28.1915C71.8102 29.5443 69.6148 29.5684 68.4713 28.2464C67.3278 26.9243 67.6701 24.7551 69.236 23.4023C70.8007 22.0494 72.9961 22.0252 74.1396 23.3473C75.2831 24.6705 74.9409 26.8385 73.3749 28.1915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0744 0.269287H63.61H58.5885L55.9604 16.5288H60.4325H63.6089C67.2339 16.5288 72.1306 12.9816 72.7716 8.39162C73.4138 3.79934 70.5133 0.269287 66.0744 0.269287ZM67.7249 8.70296C67.164 10.9304 65.1668 11.5497 64.2693 11.5497H61.7877L62.8168 5.18207H65.13C66.7315 5.1832 68.2858 6.4755 67.7249 8.70296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7073 19.3915L15.9163 25.2027C15.9163 25.2027 15.2272 23.9666 14.7946 23.598C14.3619 23.2294 13.0799 22.364 11.7979 22.4042C10.5159 22.4442 10.2836 22.8288 11.189 23.2775C12.0944 23.7262 14.2898 24.2549 15.3234 25.8575C16.357 27.46 16.3971 32.0191 11.9101 33.6856C7.42311 35.3523 4.77328 32.6177 4.28223 31.9974L5.17963 26.2982C5.17963 26.2982 6.11936 28.0026 7.46546 28.7077C8.81155 29.4127 10.4884 29.2524 10.9165 29.0179C11.3435 28.7831 9.2076 28.2269 7.95765 27.4692C6.70771 26.7103 4.98732 25.4982 5.94882 21.572C6.91146 17.6447 13.7644 15.7378 16.7073 19.3915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1762 17.6677L90.0625 24.5608L86.6949 17.6677H81.6745L79.0464 33.9274H84.0669L85.2057 26.8844L88.5481 33.9274H88.6156H93.5696L96.1977 17.6677H91.1762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4501 35.92C-0.180524 36.6891 0.00834062 39.5736 0.00834062 39.5736C2.63184 39.4844 10.2036 39.6286 20.6277 39.7729C32.6305 39.9388 48.4173 40.1059 64.7937 39.9147C95.4642 39.5576 93.6144 36.5713 93.6144 36.5713C80.1936 36.3033 44.1981 35.6316 44.1981 35.6316C39.2214 23.3243 41.6375 17.6699 41.6375 17.6699C30.8631 17.6699 25.4501 35.92 25.4501 35.92Z",
    fill: "url(#paint0_radial_129_366)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_129_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.225 36.9548) rotate(-178.206) scale(88.8834 286.954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4679,
    stopColor: "#FF7A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664EFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.204,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldstation);
export default __webpack_public_path__ + "static/media/holdstation.345796b089b0dbd1b06866eab5e7a29b.svg";
export { ForwardRef as ReactComponent };